// extracted by mini-css-extract-plugin
export default {"imageGrid":"fAwxUx","link":"xUEhry","img2":"vXixrr","img3":"a2lShG","countContainer":"k8THU0","countValue":"OWw40s"};